import {cn} from '@common-web/lib/utils';
import {useEnrollSteps} from '@client/pages/public/enroll/enrollStepsContext';
import {COVERAGE_TIER_LABELS} from '@client/pages/public/enroll/types';
import type {CoverageTier, ProductCategory} from '@client/pages/public/enroll/types';

const TIERS = Object.keys(COVERAGE_TIER_LABELS) as CoverageTier[];

interface TierSelectProps {
  category: ProductCategory;
  size?: 'default' | 'compact';
  className?: string;
}

/** Category-scoped tier picker. Each product carries its own tier in the enroll state. */
export function TierSelect({category, size = 'default', className}: TierSelectProps) {
  const {getTier, setTier} = useEnrollSteps();
  const active = getTier(category);
  const compact = size === 'compact';

  return (
    <div className={cn('inline-flex flex-wrap gap-1 rounded-lg bg-neutral-100 p-1', compact && 'p-0.5', className)}>
      {TIERS.map((value) => {
        const isActive = active === value;
        return (
          <button
            key={value}
            type='button'
            onClick={() => setTier(category, value)}
            aria-pressed={isActive}
            className={cn(
              'rounded-md font-medium transition-colors',
              compact ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm',
              isActive ? 'text-white shadow-sm' : 'text-neutral-600 hover:bg-white/70',
            )}
            style={isActive ? {backgroundColor: 'var(--enroll-primary)'} : undefined}
          >
            {COVERAGE_TIER_LABELS[value]}
          </button>
        );
      })}
    </div>
  );
}
